import { render, staticRenderFns } from "./ActiveAlertLongStayListHeader.vue?vue&type=template&id=6fc380b6&scoped=true&lang=pug"
import script from "./ActiveAlertLongStayListHeader.vue?vue&type=script&lang=ts"
export * from "./ActiveAlertLongStayListHeader.vue?vue&type=script&lang=ts"
import style0 from "./ActiveAlertLongStayListHeader.vue?vue&type=style&index=0&id=6fc380b6&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6fc380b6",
  null
  
)

export default component.exports